import { gql } from "@apollo/client";

export interface ContactTagsQuery {
  contact: {
    tagsAsSet: string[];
  };
}

/**
 * Shared document node — must be imported everywhere ContactTags is used.
 * Apollo deduplicates in-flight requests by document object reference, not
 * operation name, so a single shared gql`` call is required to avoid
 * duplicate network requests.
 */
export const CONTACT_TAGS_QUERY = gql`
  query ContactTags($contactId: Long) {
    contact(id: $contactId) {
      id
      tagsAsSet
    }
  }
`;
